<script lang="ts" setup>
  import type { PropType } from 'vue';

  type Item = {
    header: string | null;
    number: string;
  }

  defineOptions({
    inheritAttrs: false,
  });

  defineProps({
    items: { type: Array as PropType<Item[]>, required: true, default: [] },
    header: String,
    content: String,
    headerType: String,
  });
</script>
<template>
  <SfSection :title="header" :headerType v-if="items.length > 0" class="about-numbers">
    <QuillContent v-if="content" :content />
    <div class="about-numbers__content">
      <div v-for="item in items" class="about-numbers__item">
        <span v-if="item.number" class="about-numbers__item--number">{{ item.number }}</span>
        <span v-if="item.header" v-html="item.header" class="about-numbers__item--text" />
      </div>
    </div>
  </SfSection>
</template>
<style lang="scss">
  :root {
    --about-numbers-block-number-color: var(--foreground-on-primary-bg);
  }
</style>
<style lang="scss" scoped>
  .about-numbers {
    &__content {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(240px, 1fr) );
      gap: 2rem 3rem;
      background: var(--primary-color);
      padding: 2rem;
      border-radius: var(--border-radius);
    }

    &__item {
      display: flex;
      flex-direction: column;
      align-items: start;
      flex-wrap: wrap;
      gap: 0.75rem;
      font-weight: var(--font-weight-bold);
      font-size: 1.25rem;

      &--number {
        color: var(--about-numbers-block-number-color);
        font-size: 2.5rem;
        line-height: 1;
      }

      &--text {
        color: var(--foreground-on-primary-bg);
      }
    }

    @media(max-width: 767px) {
      &__content {
        justify-items: left;
        gap: 1.5rem 1rem;
        padding: 1.25rem 1rem;
        border-radius: 0;
      }

      &__item {
        gap: 0.25rem;
        font-size: 1.25rem;

        &--number {
          font-size: 1.5rem;
        }
      }
    }
  }
</style>
